// Hooks for reading moderation queues and suspensions.
import { useDatastore, useModuleMap, useModuleObject, useServerCallResult } from "util/datastore";
import { useIsAdmin } from "component/admin";
import { useEffect, useMemo, useState } from "react";
import { defineModuleMap } from "util/moduledata";

type ModTask = { time: number; [key: string]: any };
type Suspension = { isBlocked: boolean };
export const moduleMapQueue = defineModuleMap<ModTask>('PUBLIC', 'moderation', 'queue');
export const moduleMapSuspension = defineModuleMap<Suspension>('PUBLIC', 'moderation', 'suspension');

// HACK(Rob): I don't think that adding the "key" field is needed, but 
// I'm leaving it in for the moment, to keep this change behavior-neutral.
// We should remove it later.

export function useModerationQueue({options = {limit: 1000}} = {}) {
    const modObjs = useModuleMap(moduleMapQueue, options);

    // Use useMemo to prevent unnecessary recalculations if modObjs hasn't changed
    return useMemo(() => {
        if (!modObjs) {
            return [];
        }
        const keys = Object.keys(modObjs);
        return keys.map(key => ({...modObjs[key], key})).sort((a, b) => b.time - a.time);
    }, [modObjs]); 
}

export function useModerationAuthors() {
    const queue = useModerationQueue();

    const isAdmin = useIsAdmin();
    const datastore = useDatastore();
    const [modAuthors, setModAuthors] = useState({}); 

    async function fetchModerationAuthors() {
        const result = await datastore.callServerAsync('moderation', 'getModItemAuthors');
        setModAuthors(result);
    }

    useEffect(() => {
        if (isAdmin) {
            fetchModerationAuthors();
        }
    }, [isAdmin, queue.length]);
    return modAuthors;
}
